module.exports = __webpack_public_path__ + "img/c01_unitstartechbatteringramchampion_Normal_ua.65d45836.webp";